module.exports = __webpack_public_path__ + "img/SAVE_NEW.c4b27b16.svg";